import { FC } from 'react';
import { Text } from '@chakra-ui/react';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';

interface RevokeQrCodeDialogProps {
  isOpen: boolean;
  onClose: () => void;
  handleAction: () => void;
  songTitle: string;
}

export const RevokeQrCodeDialog: FC<RevokeQrCodeDialogProps> = ({
  isOpen,
  handleAction,
  onClose,
  songTitle,
}) => (
  <ChakraConfirmationDialog
    title="Revoke QR"
    actionButtonText="Revoke"
    isOpen={isOpen}
    handleAction={handleAction}
    onClose={onClose}
  >
    <Text as="span" fontSize="md" lineHeight="24px">
      <div>Are you sure you want to revoke the QR code?</div>
      <div>
        {`Once revoked, contributors won't be able to use it to join the song ${songTitle}.`}
      </div>
    </Text>
  </ChakraConfirmationDialog>
);
